import React from 'react'
// import React, { lazy, Suspense } from 'react'
import loadable from '@loadable/component'
import { Spin } from 'antd'
import { Route, Navigate, Routes, useLocation, useParams, useNavigate } from 'react-router-dom'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'
import { history as globalHistory } from 'index'
import { getDefaultPage } from 'env'

import { parseSearchParam, processNParam } from 'utils'

import Layout from 'layouts'

export function withRouter(Component, options) {
  return (props) => {
    const newProps = {
      ...props,
    }

    newProps.location = useLocation()
    newProps.navigate = useNavigate()
    newProps.history = globalHistory
    newProps.match = {
      params: useParams(),
      path: newProps.location.pathname,
    }

    if (options != null && options.navigate === true) {
      newProps.navigate = useNavigate()
    }

    return <Component {...newProps} />
  }
}

const config = {
  fallback: <Spin />,
}

function getRoutes() {
  const routes = [
    {
      path: '/main',
      Component: loadable(() => import('pages/main'), config),
    },
    {
      path: '/details',
      Component: loadable(() => import('pages/details'), config),
    },
    // {
    //   path: '/test',
    //   Component: loadable(() => import('pages/test'), config),
    // },
    {
      path: '/v1/darkweb/login/web/:key',
      Component: loadable(() => import('pages/main'), config),
    },
    // {
    //   path: '/auth/login',
    //   Component: loadable(() => import('pages/auth/login'), config),
    //   exact: true,
    // },
    // {
    //   path: '/auth/register',
    //   Component: loadable(() => import('pages/auth/register'), config),
    //   exact: true,
    // },
    {
      path: '/auth/lockscreen',
      Component: loadable(() => import('pages/auth/lockscreen'), config),
      exact: true,
    },
    {
      path: '/auth/404',
      Component: loadable(() => import('pages/auth/404'), config),
      exact: true,
    },
    {
      path: '/auth/500',
      Component: loadable(() => import('pages/auth/500'), config),
      exact: true,
    },
  ]

  return routes
}

const mapStateToProps = ({ user, settings }) => ({
  routerAnimation: settings.routerAnimation,
  routerAnimationReverse: settings.routerAnimationReverse,
  serverType: user.serverType,
})

@connect(mapStateToProps)
class Router extends React.Component {
  constructor(props) {
    super(props)
    // store.set('app.router.location', '');

    const { history } = props
    this.unsubscribeFromHistory = history.listen(this.handleLocationChange)
    this.handleLocationChange(history.location)
  }

  // componentDidMount() {
  // }

  componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory()
  }

  handleLocationChange = (e) => {
    const { history } = this.props
    console.log('ROUTE CHANGED', e, history)

    parseSearchParam()
    processNParam()
  }

  // const Router = ({ history, routerAnimation, serverType }) => {
  render = () => {
    const { location, routerAnimation } = this.props

    const myRoutes = getRoutes()

    const defaultPage = getDefaultPage()

    let animationType = routerAnimation

    return (
      <Layout>
        <SwitchTransition>
          <CSSTransition
            key={location.pathname}
            appear
            classNames={animationType}
            timeout={routerAnimation === 'none' ? 0 : 300}
          >
            <Routes location={location}>
              <Route exact path="/" element={<Navigate to={defaultPage} />} />
              {myRoutes.map(({ path, Component, exact }) => (
                <Route
                  path={path}
                  key={path}
                  exact={exact}
                  element={
                    <div className={routerAnimation}>
                      <Component />
                    </div>
                  }
                />
              ))}
              <Route exact path="*" element={<Navigate to="/auth/404" />} />
            </Routes>
          </CSSTransition>
        </SwitchTransition>
      </Layout>
    )
  }
}

export default connect(mapStateToProps)(withRouter(Router))
